import {
  SocureIdvDelivery,
  SocureIdvStepAssets,
} from "@dreambigger/shared/src/types";

const KNOWN: SocureIdvDelivery[] = ["inline", "email", "text"];

/**
 * The delivery mode a step is actually configured for.
 *
 * Two things this has to get right, and neither is obvious from the types:
 *
 * 1. `delivery` beats the deprecated `deliverByEmail`. A flow configured before
 *    `delivery` existed keeps working through the fallback, and one migrated to
 *    `delivery` is not second-guessed by a `deliverByEmail: true` the settings UI
 *    left behind.
 * 2. An UNRECOGNIZED `delivery` degrades to `inline`, never to a hand-off. Step
 *    assets are not validated server-side (`updateStep.ts` has a `plaid-idv`
 *    case and no `socure-idv` one), so a typo reaches this function — and the
 *    safe failure is "the applicant sees a QR code", not "the step waits
 *    forever for a link nobody sent".
 */
export const resolveDelivery = (
  assets?: Pick<SocureIdvStepAssets, "delivery" | "deliverByEmail">
): SocureIdvDelivery => {
  const configured = assets?.delivery;
  if (configured && KNOWN.includes(configured)) {
    return configured;
  }
  return assets?.deliverByEmail ? "email" : "inline";
};
